import { DirectoryStoreState } from '../types';
import { combineReducers, Reducer } from 'redux';
import { stores } from './stores';
import { extensions } from './extensions';
import { queryString } from './queryString';

const reducersMap: { [key in keyof Extract<'_persist', DirectoryStoreState>]: Reducer<any> } = {
  stores,
  extensions,
  queryString,
};

export const rootReducer: Reducer<DirectoryStoreState> = combineReducers(reducersMap);
